import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const purchaseTrainingRoute: RouteConfig<'with-page'> = {
    name: 'Purchase Training',
    path: '/training/courses',
    page: lazy(() => import('.')),
    flags: ['member-route'],
    context:'member'
}